module.exports = __webpack_public_path__ + "img/unhappy.49317c43.png";